module.exports = __webpack_public_path__ + "static/invoker-60bf6124890ec332041ee90bde4e2f76.png";